import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
const links = [{
  label: 'My Work',
  href: '/work'
}, {
  label: 'LinkedIn',
  href: 'https://www.linkedin.com/in/teddy-ni/'
}, {
  label: 'GitHub',
  href: 'https://github.com/Teddarific'
}];
const ease = [0.23, 1, 0.32, 1] as const;
export function Home() {
  return <main className="mx-auto flex w-full max-w-[86rem] flex-1 flex-col justify-center px-6 py-24 md:px-10" data-id="element-72" data-mp="1zih5s34lpvhm">
      <motion.h1 initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease
    }} className="text-5xl font-medium leading-[1.02] tracking-tightest text-ink sm:text-7xl md:text-[104px]" data-id="element-73" data-mp="24g8wittifbk8">
        Hey, I&rsquo;m Teddy.
      </motion.h1>

      <motion.p initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      delay: 0.08,
      ease
    }} className="mt-8 max-w-xl text-[19px] leading-relaxed text-ink-muted md:text-xl" data-id="element-74" data-mp="3ku8tpx0z0n3s">
        Currently building the best AI design tool{' '}
        <a href="https://www.magicpatterns.com" target="_blank" rel="noreferrer" className="text-ink underline decoration-rule underline-offset-4 transition-colors duration-150 ease-expo hover:decoration-ink" data-id="element-75" data-mp="2vyzydprbkhcx">
          @MagicPatterns
        </a>
      </motion.p>

      <nav aria-label="Elsewhere" className="mt-12 md:mt-14" data-id="element-76" data-mp="2hz8dr66as2py">
        <ul className="flex flex-wrap items-center gap-x-10 gap-y-4" data-id="element-77" data-mp="2d6xcnzztmavt">
          {links.map((link, i) => {
          const isExternal = link.href.startsWith('http');
          const content = <>
                <span className="border-b border-rule pb-0.5 transition-colors duration-150 ease-expo group-hover:border-ink" data-id="element-78" data-mp="23ac6hbc2etqe">
                  {link.label}
                </span>
                <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-expo group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-79" data-mp="1u82z2uc3fgh8" />
              </>;
          const className = 'group inline-flex items-center gap-1 text-[17px] text-ink-muted transition-colors duration-150 ease-expo hover:text-ink md:text-lg';
          return <motion.li key={link.label} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.25,
            delay: 0.12 + i * 0.05,
            ease
          }} data-id="element-80" data-mp="1fnh046gmeett" data-mpi={i}>
                {isExternal ? <a href={link.href} target="_blank" rel="noreferrer" className={className} data-id="element-81" data-mp="1tl5c0ospmbmq">
                    {content}
                  </a> : <Link to={link.href} className={className} data-id="element-82" data-mp="2m91e6911svqw">
                    {content}
                  </Link>}
              </motion.li>;
        })}
        </ul>
      </nav>
    </main>;
}